import React from 'react';
import { useSwiper } from 'swiper/react';

import { NavigateNext } from '@mui/icons-material';

import './index.scss';

const SliderNextButton = () => {
  const swiper = useSwiper();

  return (
    <button className='slider-next-button' onClick={() => swiper.slideNext()}>
      <NavigateNext/>
    </button>
  );
};

export default SliderNextButton;
